const handler = tracker => ({
  trackClosedProjectsTab: metadata => {
    tracker().trackEvent("Ha abierto la pestaña de proyectos cerrados", metadata)
  }
})

export default handler